/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 3.9.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateClientAsAdmin400Response,
  CreateClientAsAdmin401Response,
  CreateClientAsAdmin402Response,
  GetPasswordChangeLink200Response,
  GetUser200Response,
  ValidateSession200Response,
} from '../models/index';
import {
    CreateClientAsAdmin400ResponseFromJSON,
    CreateClientAsAdmin400ResponseToJSON,
    CreateClientAsAdmin401ResponseFromJSON,
    CreateClientAsAdmin401ResponseToJSON,
    CreateClientAsAdmin402ResponseFromJSON,
    CreateClientAsAdmin402ResponseToJSON,
    GetPasswordChangeLink200ResponseFromJSON,
    GetPasswordChangeLink200ResponseToJSON,
    GetUser200ResponseFromJSON,
    GetUser200ResponseToJSON,
    ValidateSession200ResponseFromJSON,
    ValidateSession200ResponseToJSON,
} from '../models/index';

export interface UpdateUserRequest {
    getUser200Response: GetUser200Response;
}

/**
 * 
 */
export class UserApi extends runtime.BaseAPI {

    /**
     * End user Keycloak user session
     */
    async endKeycloakSessionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user/keycloak/end-session`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * End user Keycloak user session
     */
    async endKeycloakSession(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.endKeycloakSessionRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get Keycloak password change link
     */
    async getPasswordChangeLinkRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPasswordChangeLink200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user/password/change`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPasswordChangeLink200ResponseFromJSON(jsonValue));
    }

    /**
     * Get Keycloak password change link
     */
    async getPasswordChangeLink(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPasswordChangeLink200Response> {
        const response = await this.getPasswordChangeLinkRaw(initOverrides);
        return await response.value();
    }

    /**
     * update email subscription user
     */
    async getSubscriptionUpdateEmailRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user/email-subscription/update`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * update email subscription user
     */
    async getSubscriptionUpdateEmail(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getSubscriptionUpdateEmailRaw(initOverrides);
    }

    /**
     * Get Keycloak user
     */
    async getUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUser200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUser200ResponseFromJSON(jsonValue));
    }

    /**
     * Get Keycloak user
     */
    async getUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUser200Response> {
        const response = await this.getUserRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get Keycloak webhooks
     */
    async handleUserWebhooksRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user/webhook`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get Keycloak webhooks
     */
    async handleUserWebhooks(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.handleUserWebhooksRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update user
     */
    async updateUserRaw(requestParameters: UpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['getUser200Response'] == null) {
            throw new runtime.RequiredError(
                'getUser200Response',
                'Required parameter "getUser200Response" was null or undefined when calling updateUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/user/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetUser200ResponseToJSON(requestParameters['getUser200Response']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update user
     */
    async updateUser(getUser200Response: GetUser200Response, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUserRaw({ getUser200Response: getUser200Response }, initOverrides);
    }

    /**
     * Validate user session
     */
    async validateSessionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidateSession200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user/session/validate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidateSession200ResponseFromJSON(jsonValue));
    }

    /**
     * Validate user session
     */
    async validateSession(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidateSession200Response> {
        const response = await this.validateSessionRaw(initOverrides);
        return await response.value();
    }

}
